export default "__VITE_ASSET__CwvCYzml__"